import React from 'react'

import moment from 'moment'
import PropTypes from 'prop-types'

import map from 'lodash/map'

import { momentFriendlyDateFormat } from '@smartcoop/utils/dates'

import useStyles, {
  TabsGroup,
  TabItem,
  TabContainer,
  DateText
} from './styles'

const DateTabs = ({
  onChange,
  value,
  indicators
}) => {
  const classes = useStyles()

  return (
    <TabsGroup
      value={ value }
      onChange={ onChange }
      classes={ classes }
      textColor="inherit"
      variant="scrollable"
      scrollButtons="auto"
      aria-label="dates by field indexes"
    >
      { map(indicators, item => {

        const label = (
          <>
            <TabContainer>
              <DateText>{moment(item).format(momentFriendlyDateFormat)}</DateText>
            </TabContainer>
          </>
        )

        return <TabItem label={ label } key={ item } />
      })}
    </TabsGroup>
  )
}

DateTabs.propTypes = {
  value: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
  indicators: PropTypes.array.isRequired
}

export default DateTabs
